// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b732d4db","239":"f0080546","453":"41bd5d51","667":"bf0d099b"}[chunkId] + ".chunk.js";
};